<template>
    <div class="mb-40">
        <SuccessModal v-if="showSucessModal" :message="sucessMessage" @return="showSucessModal = false" > </SuccessModal>

        <!--NAME FORM-->
        <FormModal
            v-if="showNameForm"
            @cancel="showNameForm=false;userUpdateRequest.firstName = userDetails.firstName; userUpdateRequest.lastName = userDetails.lastName"
            @confirm="updateUserDetails()"
            :valid="validateUserDetails"
            title="Update your details"
            subtitle="Update your fist name, last name and content settings"
            submitButtonText="Save changes"
        >
        <CustomInput :error="errors.firstName" class="w-full" v-model="userUpdateRequest.firstName" type="text" placeholder="First Name" />
        <CustomInput :error="errors.lastName" class="w-full" v-model="userUpdateRequest.lastName" type="text" placeholder="Last Name" />
        <CustomSelect v-model="userUpdateRequest.contentNotifications" class="w-full mt-2" :options="trueOrFalse" label="Receive content notifications" />

        <ErrorNotification :errorMessage="userUpdateRequestFormError" />
        </FormModal>
        <!--PASSWORD FORM-->
        <FormModal
            v-if="showPasswordForm"
            @cancel="showPasswordForm=false"
            @confirm="updateUserPassword()"
            :valid="matching"
            title="Set a new password"
            subtitle="Create and replace your old password"
            submitButtonText="Save changes"
        >

            <ErrorNotification :errorMessage="userUpdatePasswordRequestError" />

            <CustomInput class="w-full" v-model="userUpdatePasswordRequest.currentPassword" type="password"
                placeholder="Current password" />
            <CustomInput class="w-full" v-model="userUpdatePasswordRequest.newPassword" type="password"
                placeholder="New password" />
            <CustomInput class="w-full" v-model="confirmPassword" type="password"
                placeholder="Confirm password" />

            <div class="text-gray-700 text-sm">
				<h2 class="font-medium">Password requirements</h2>
				<p >Please follow this guide for a strong password</p>
				<p :class="emailStrong.special ? 'text-blue-600 font-medium':'text-gray-700'">- One special character</p>
				<p :class="emailStrong.length ? 'text-blue-600 font-medium':'text-gray-700'">- Min 8 characters</p>
				<p :class="emailStrong.number ? 'text-blue-600 font-medium':'text-gray-700'">- One number (2 recommended)</p>
				<p :class="emailStrong.capital ? 'text-blue-600 font-medium':'text-gray-700'">- One capital</p>
				<p :class="matching ? 'text-blue-600 font-medium':'text-gray-700'">- Matching</p>
				
			</div>

        </FormModal>
        <!--INVITE NEW USER FORM-->
        <FormModal
            v-if="showInviteUserForm"
            @cancel="showInviteUserForm=false"
            @confirm="handleInviteUser()"
            :valid="validInviteUser"
            title="Invite a new user"
            subtitle="Send an email invite to a team member"
            submitButtonText="Send invite"
        >
            <ErrorNotification :errorMessage="userInviteRequestFormError" />
            <CustomInput class="w-full" v-model="inviteUserRequest.email" type="email" placeholder="Email" />
        </FormModal>
        <Header title="Settings" icon="Cog">
        </Header>
        <WhiteBox title="Update your details">
            <template v-slot:buttons>
                <CustomButton class="" small text="Update details" icon="Pencil"
                    type="action" @click="showNameForm = true" />
                    <CustomButton class="" small text="Change password" icon="Key"
                    type="action" @click="showPasswordForm = true" />
            </template>
            <template v-slot:content>
                <div class="w-full">
                    <div class="flex justify-start items-center gap-2">
                        <p class="text-sm font-semibold w-32">First name:</p>
                        <div class="border-l pl-3 py-1">
                            <p class="text-sm font-medium">{{ userDetails.firstName }}</p>
                        </div>
                    </div>
                    <div class="flex justify-start items-center gap-2">
                        <p class="text-sm font-semibold w-32">Last name:</p>
                        <div class="border-l pl-3 py-1">
                            <p class="text-sm font-medium">{{ userDetails.lastName }}</p>
                        </div>
                    </div>
                    <div class="flex justify-start items-center gap-2">
                        <p class="text-sm font-semibold w-32">Send content notifications:</p>
                        <div class="border-l pl-3 py-1">
                            <p v-if="userDetails.sendContentNotifications == 'true'" class="text-sm font-medium">Yes</p>
                            <p v-else class="text-sm font-medium">No</p>
                            
                        </div>
                    </div>
                </div>
            </template>
        </WhiteBox>

        <WhiteBox title="Manage users" subText="Invite and manage users who can access your dashboard">
            <template v-slot:buttons>
                <CustomButton class="" small text="Invite new user" icon="UserPlus" type="action" @click="showInviteUserForm = true" />
            </template>
            <template v-slot:content>
                <EasyDataTable :headers="userHeaders" :items="publisherUsers" :loading="loading" :hide-footer="true"
                    :table-min-height="0" :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-action=val>
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton @confirmClick="resetPassword(val.id)" id="downloadReport" small text="Send password reset link"
                                icon="SendHorizontal" type="action"
                                
                                :requiresConfirmation="true"
                                confrimationModalTitle="Send reset password request"
                                confrimationModalMessage="Confirm you would like to send a reset password request"
                                confrimationModalButtonText="Send"
                                
                                />
                            <CustomButton id="downloadReport" @confirmClick="deleteUser(val.id)"
                                v-if="(val.publisherUserRole == 'ADMIN' && publisherUsers.filter(user => user.publisherUserRole == 'ADMIN').length > 1) || val.publisherUserRole == 'USER'"
                                small text="" icon="Trash2" type="warning" 
                                
                                :requiresConfirmation="true"
                                confrimationModalTitle="Deleter user account"
                                confrimationModalMessage="Confirm you would like to delete this user"
                                confrimationModalButtonText="Delete"
                                
                                />
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>


    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import CustomButton from '@/components/inputs/CustomButton.vue';
import CustomInput from '@/components/inputs/CustomInput.vue';
import WhiteBox from '@/components/WhiteBox.vue';
import FormModal from '@/components/modals/FormModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';

import ErrorNotification from '@/components/inputs/ErrorNotification.vue';
import CustomSelect from '@/components/inputs/CustomSelect.vue';


export default {
    name: 'Settings-page',
    components: {
        Header,
        CustomButton,
        CustomInput,
        WhiteBox,
        FormModal,
        ErrorNotification,
        SuccessModal,
        CustomSelect

    },
    data() {
        return {
            showNameForm: false,
            showPasswordForm: false,
            showInviteUserForm: false,
            publisher: localStorage.getItem('publisher'),
            showSucessModal:false,
            sucessMessage: "",

            userDetails:{
                firstName: localStorage.getItem("firstName"),
                lastName: localStorage.getItem("lastName"),
                sendContentNotifications: localStorage.getItem("sendContentNotifications")

            },


            trueOrFalse: [
                { id: true, text: "Yes" },
                { id: false, text: "No" },

            ],

            userUpdateRequest: {
                firstName: localStorage.getItem("firstName"),
                lastName: localStorage.getItem("lastName"),
                contentNotifications: localStorage.getItem("sendContentNotifications")

            },
            userUpdatePasswordRequest: {
                currentPassword: "",
                newPassword: "",
            },
            confirmPassword: "",
            inviteUserRequest: {
                email: "",
                publisherId: ""
            },

            userUpdatePasswordRequestError:"",
            userUpdateRequestFormError:"",
            userInviteRequestFormError:"",


            emailStrong:{
			special:false,
			length:false,
			number:false,
			capital:false,
			},
            errors:{
                firstName:"",
                lastName:""
            },

            userData:{},

            userHeaders: [
                { text: "First Name", value: "firstName" },
                { text: "Last Name", value: "lastName" },
                { text: "Role", value: "publisherUserRole" },
                { text: "Email", value: "email" },
                { text: "ACTION", value: "action" }
            ],
            publisherUsers: [],

        }
    },
    mounted() {
        this.getPublisherUsers()
        this.getUser()
        document.title = "Settings";
    },
    computed: {
        matching()
		{
			return (this.userUpdatePasswordRequest.newPassword === this.confirmPassword && this.userUpdatePasswordRequest.currentPassword != ''&& this.userUpdatePasswordRequest.newPassword != '' )
		},
		secure()
		{
			return (this.emailStrong.length && this.emailStrong.special && this.emailStrong.number && this.emailStrong.capital)
		},
        validateUserDetails()
        {
            return !(this.userUpdateRequest.firstName == "" || this.userUpdateRequest.lastName == "")
            
        },
        validInviteUser() {
            // eslint-disable-next-line
            const mailRegex = new RegExp(/^(([^\<\>\(\)\[\]\\\^\.\,\;\:\`\{\}\?\!\|\~\s@"]+(\.[^\<\>\(\)\[\]\\\^\.\,\;\:\`\{\}\?\!\|\~\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
            if (mailRegex.test(this.inviteUserRequest.email)) {
                return true
            } else
                return false
        },
    },
    watch:{

        userUpdateRequest:{
            deep:true,
            handler: function(val){
                if(val.firstName == "" )
                {
                    this.errors.firstName = "This can't be empty"
                }else
                {
                    this.errors.firstName = ""
                }
                if(val.lastName == "" )
                {
                    this.errors.lastName = "This can't be empty"
                }
                else
                {
                    this.errors.lastName = ""
                }
                
            }
        },

        userUpdatePasswordRequest:{
		deep: true,
		handler: function(val){
				
						if (val.newPassword.match(/^(?=.*[A-Z])/)) {
							this.emailStrong.capital = true}
						else
						{
						this.emailStrong.capital = false;
						}
						if (val.newPassword.match(/^(?=.*[0-9])/)) { 
							this.emailStrong.number = true}
						else
						{
						this.emailStrong.number = false;
						}
						if (val.newPassword.match(/^(?=.*[!@#$%^&*-])/)){ 
							this.emailStrong.special = true}
						else
						{
						this.emailStrong.special = false;
						}
						if (val.newPassword.match(/^(?=.{8,})/)) {
							this.emailStrong.length = true}
						else
						{
						this.emailStrong.length = false;
						}
		}
	}
    },
    methods: {

        async resetPassword(userId) {
            try {
                const token = localStorage.getItem('token')
                const response = await this.$apiFetch(`https://dev.boogi.io/private/api/client/publisher/user/${userId}/reset`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.showResetSuccessModal = true
       


                } else {
                    this.userUpdatePasswordRequestError = "Current password is incorrect"
      
                }

            } catch (e) {
                console.error(e)
                this.userUpdatePasswordRequestError = "Current password is incorrect"

            }
        },


        async deleteUser(userId) {
            try {
                const token = localStorage.getItem('token')
                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/publisher/user/${userId}/delete`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.getPublisherUsers(this.publisherId)
                } else {
                    this.showErrorModal = true
                }

            } catch (e) {
                console.error(e)
                this.showErrorModal = true
            }
        },

        async updateUserDetails() {
            try {
                const token = localStorage.getItem('token')

                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/user/update/details`, {
                    method: "POST",
                    body: JSON.stringify(this.userUpdateRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                        this.getUser()
                        this.showNameForm = false
                } else {
                    this.showErrorModal = true
                }

            } catch (e) {
                console.error(e)
                this.showErrorModal = true
            }
        },

        async updateUserPassword() {
            try {
                const token = localStorage.getItem('token')

                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/user/update/password`, {
                    method: "POST",
                    body: JSON.stringify(this.userUpdatePasswordRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.userUpdatePasswordRequest = {
                        currentPassword: "",
                        newPassword: "",
                    }
                    this.confirmPassword = ""
                        
                         this.showPasswordForm = false
                         this.sucessMessage = "Password has been reset successfully"
                         this.showSucessModal = true
                } else {
                    this.userUpdatePasswordRequest = {
                        currentPassword: "",
                        newPassword: "",
                    }
                    this.confirmPassword = ""
                    this.userUpdatePasswordRequestError = "Password is incorrect"
                }

            } catch (e) {
                console.error(e)
                this.userUpdatePasswordRequest = {
                        currentPassword: "",
                        newPassword: "",
                    }
                    this.confirmPassword = ""
                this.userUpdatePasswordRequestError = "Password is incorrect"
            }
        },

        async getUser(){
			try {
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/user`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
                    this.userData = object

					var publisher = object.publisher.companyName
                    localStorage.setItem("firstName",object.publisherUser.firstName)
					localStorage.setItem("lastName", object.publisherUser.lastName)
                    localStorage.setItem("sendContentNotifications", object.publisherUser.sendContentNotifications)
					localStorage.setItem("publisher",publisher)

                    this.userDetails = {
                        firstName: localStorage.getItem("firstName"),
                        lastName: localStorage.getItem("lastName"),
                        sendContentNotifications: localStorage.getItem("sendContentNotifications")
                    }

                    window.dispatchEvent(new CustomEvent('foo-key-localstorage-changed', {
                    detail: {
                    storage: localStorage.getItem('firstName') + " " + localStorage.getItem('lastName')
                    }
                    }));
    
				}
				
			} catch (error) {
				return;
			}

		},


        async handleInviteUser() {
            try {
                const token = localStorage.getItem('token')

                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/publisher/user/invite`, {
                    method: "POST",
                    body: JSON.stringify(this.inviteUserRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.showInviteUserForm = false
                    this.inviteUserRequest = {
                        email: "",
                        admin: false,
                    },
                        this.sucessMessage = "User has been invited successfully"
                        this.showSucessModal = true
                } else {
                    this.userInviteRequestFormError = "This email already exists in our system"
                    
                }

            } catch (e) {
                console.error(e)
                this.userInviteRequestFormError = "This email already exists"
            }
        },

        async getPublisherUsers() {
            try {
                const token = localStorage.getItem('token')


                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/publisher/users`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.publisherUsers = object.content
                    this.loading = false


                }

            } catch (error) {
                return;
            }

        },

    }

}
</script>

<style></style>